<template>
	<div>
		<v-dialog v-model="dialog" persistent max-width="500px">
			<v-card>
				<v-form>
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>

					<v-divider></v-divider>
					<v-card-text>
						<v-select v-model="selected" :items="optionsFiltered" item-disabled="disabled" label="Reminder" return-object required></v-select>

						<v-subheader class="mt-3 pl-0">Delivery Method</v-subheader>

						<v-switch v-model="email" readonly>
							<div slot="label"><v-icon>email</v-icon> Email</div>
						</v-switch>
						<v-switch v-model="sms" readonly>
							<div slot="label"><v-icon>mdi-cellphone</v-icon> SMS (Coming Soon!)</div>
						</v-switch>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat @click="closeEditor">Cancel</v-btn>
						<v-btn :disabled="!validForm" color="primary" flat @click="submit">Save</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import remindersMixin from '@/mixins/remindersMixin';

	export default {
		props: {
			dialog: {},
			title: {
				type: String,
				required: true
			},
			reminder: {
				type: Object,
				default: () => ({
					id: null,
					createdDateUTC: null,
					createdByEmployeeId: null,
					deliveryMethods: [],
					minutesBefore: 1440,
					status: 0
				})
			},
			existingReminders: {
				type: Array,
				required: false
			},
			defaultMinutes: {
				type: Number,
				required: false
			}
		},
		created() {
			if (this.reminder.id === null) {
				if (this.defaultMinutes && this.existingReminders.find(x => x.minutesBefore === this.defaultMinutes) === undefined) {
					this.selected = this.options.find(x => x.minutes === this.defaultMinutes);
				} else {
					for (let i = 0; i < this.options.length; i++) {
						if (this.existingReminders.find(x => x.minutesBefore === this.options[i].minutes) === undefined) {
							this.selected = this.options[i];
							break;
						}
					}
				}
			} else {
				this.selected = this.options.find(x => x.minutes === this.reminder.minutesBefore);
			}
		},
		mixins: [remindersMixin],
		data() {
			return {
				email: true,
				sms: false,
				form: {
					id: this.reminder.id,
					deliveryMethods: this.reminder.deliveryMethods,
					minutesBefore: this.reminder.minutesBefore,
					status: this.reminder.status
				},
				selected: null
			};
		},
		computed: {
			optionsFiltered() {
				return this.options.map(x => {
					let isDisabled = false;

					if (this.form.id == null) {
						isDisabled = this.existingReminders.find(e => e.minutesBefore === x.minutes);
					} else {
						isDisabled = this.existingReminders.find(e => e.minutesBefore === x.minutes && x.minutes !== this.form.minutesBefore);
					}

					if (isDisabled) {
						x.text = `${x.text} (reminder exists)`;
					}

					x.disabled = isDisabled;

					return x;
				});
			},
			validForm() {
				return this.selected !== null;
			}
		},
		methods: {
			submit() {
				let postObj = {
					id: this.form.id != undefined ? this.form.id : this.newGuid(),
					// deliveryMethods: this.form.deliveryMethods,
					minutesBefore: this.selected.minutes,
					deliveryMethods: [0]
				};
				this.$emit('save', postObj);
				this.closeEditor();
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			},
			clear() {
				this.selected = null;
			}
		}
	};
</script>
<style></style>
